/**
 * Created by coolguy on 2017/8/10.
 */

import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('oppo');
const OPPO_LIST = "OPPO_LIST";
const OPPO_ADD = "OPPO_ADD";
const OPPO_DELETE = "OPPO_DELETE";
const OPPO_EDIT = "OPPO_EDIT";
const OPPO_DETAIL = "OPPO_DETAIL";

export default {
    OPPO_LIST,
    oppoList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:OPPO_LIST,
                data
            })
        })
    },
    OPPO_ADD,
    oppoAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:OPPO_ADD,
                data
            })
        })
    },
    OPPO_DELETE,
    oppoDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:OPPO_DELETE,
                data,
            })
        })
    },
    OPPO_EDIT,
    oppoEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:OPPO_EDIT,
                data,
            })
        })
    },
    OPPO_DETAIL,
    oppoDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:OPPO_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/OppoAction.js